'use strict';

/**
 * Apply a color to the part of the console output that is generated by the logger. This concatenates previous output!
 * @param {Array} result - The initial output args
 * @param {Object} data - The data object with all necessary runtine information
 * @param {Object} data.level - The output's log level object
 * @return {Array} The resulting output args
 */
function colorize(result, ref) {
    var level = ref.level;

    var color = level.color;
    var styles = color ? ("color: " + color) : '';

    if (styles) {
        result = [("%c" + (result.join(' '))), styles];
    }

    return result;
}

/**
 * Prepend the log level label to the output
 * @param {Array} result - The initial output args
 * @param {Object} data - The data object with all necessary runtine information
 * @param {Object} data.level - The output's log level object
 * @return {Array} The resulting output args
 */
function iconize(result, ref) {
    var level = ref.level;

    var label = level.label;

    if (label) {
        result.unshift(("" + label));
    }

    return result;
}

/**
 * Prepend a location to the output if available
 * @param {Array} result - The initial output args
 * @param {Object} data - The data object with all necessary runtine information
 * @param {Object} data.config - The config that the logger was invoked with
 * @return {Array} The resulting output args
 */
function localize(result, ref) {
    var config = ref.config;

    var ref$1 = config.context;
    var location = ref$1.location;

    if (location) {
        result.unshift(("[" + location + "]"));
    }

    return result;
}

var presets = {
    logger: window.console,
    proxy: true,
    context: {},
    filter: function () { return true; },
    levels: [
        {
            name: 'debug',
            fn: window.console.debug,
            label: '🗒',
            color: 'grey',
        },
        {
            name: 'log',
            fn: window.console.log,
            label: '📎',
            color: 'grey',
        },
        {
            name: 'info',
            fn: window.console.info,
            label: '💎️',
            color: '#6060BA',
        },
        {
            name: 'warn',
            fn: window.console.warn,
            label: '',
            color: '#817123',
        },
        {
            name: 'error',
            fn: window.console.error,
            label: '',
            color: '#A16666',
        } ],
    middlewares: [localize, iconize, colorize],
};

/**
 * Just a noop
 */
function noop() {
    // NOTE: Intentionally do nothing
}

/**
 * Define loggers for vue instances
 * @param {Object} target - The host object
 * @param {Object} config - A config object for the logger instance
 * @param {Object} instance - A vue component instance that is allowed to influence part of the logging string
 * @return {Function} The original target object enhanced with a logger instance
 */
function createLogger(target, config, instance) {
    var context = config.context;
    var filter = config.filter;
    var levels = config.levels;
    var logger = config.logger;
    var middlewares = config.middlewares;
    var proxy = config.proxy;

    return levels.reduce(function (host, level) {
        return Object.defineProperty(host, level.name, {
            get: function get() {
                if (!level.fn || !filter({ config: config, level: level, instance: instance })) {
                    return noop;
                }

                if (proxy) {
                    var args = middlewares.reduce(function (acc, m) { return m(acc, { level: level, config: config, instance: instance }); }, []);
                    return (ref = level.fn).bind.apply(ref, [ logger ].concat( args ));
                }

                return function() {
                    var statements = [], len = arguments.length;
                    while ( len-- ) statements[ len ] = arguments[ len ];

                    var args = middlewares.reduce(function (acc, m) { return m(acc, { level: level, config: config, instance: instance, statements: statements }); }, []);
                    (ref = level.fn).call.apply(ref, [ logger ].concat( args ));
                    var ref;
                };
                var ref;
            },
        });
    }, target);
}

function createConfig() {
    var cfg = [], len = arguments.length;
    while ( len-- ) cfg[ len ] = arguments[ len ];

    return Object.assign.apply(Object, [ {}, presets ].concat( cfg ));
}

/**
 * Apply a color to the part of the console output that is generated by the logger. This concatenates previous output!
 * @param {Array} result - The initial output args
 * @param {object} data - The data object with all necessary runtine information
 * @param {object} data.config - The config that the logger was invoked with
 * @param {object} data.instance - A vue instance
 * @return {Array} The resulting output args
 */
function localizeByVm(result, ref) {
    var config = ref.config;
    var instance = ref.instance;

    var ref$1 = config.context;
    var location = ref$1.location;

    if (!location && instance) {
        var tag = instance.$options._componentTag;
        var uid = instance._uid;

        location = tag ? (tag + " #" + uid) : ("#" + uid);

        result.unshift(("[" + location + "]"));
    }

    return result;
}

var presets$1 = createConfig({
    middlewares: [localize, localizeByVm, iconize, colorize],
});

/**
 * Install `vue-logger`
 */
var config;
var plugin = {};

plugin.install = function(Vue, presets$$1) {
    if (plugin.installed) { return; }
    plugin.installed = true;

    config = createConfig(presets$1, presets$$1);

    // Add logger to vue components
    Object.defineProperty(Vue.prototype, '$log', {
        get: function get() {
            return createLogger({}, config, this);
        },
    });

    // Add general logger and logging creator to vue components
    Object.defineProperty(Vue, 'log', {
        get: function get() {
            var log = function (options) { return createLogger({}, createConfig(config, options)); };
            return createLogger(log, config);
        },
    });
};

module.exports = plugin;
